import React, { useEffect, useState } from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import getCustomerTypes from "../../apis/getCustomerType";
import getAllRecruitmentPartnersAndClients from "../../apis/getAllRecruitmentPartnersAndClients";
import Close from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import axios from "axios";
import { DateTime } from "luxon";
import DataTable from "../../components/DataTable/DataTable";
import DatePicker from "react-datepicker";

const Customer = ({openModal,setOpenModal}) => {
  const jsonConfig = require("../../Config.json");
  const [allData, setAllData] = useState([]);

  const [isOpend, setIsOpend] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    custName: "",
    status: "",
    custType: "",
    customerId: "",
  })

  const [recruiterData, setRecruiterData] = useState([]);
  const [recruitmentPartnerArr, setRecruitmentPartnerArr] = useState([]);
  const [recruitOrg, setRecruitOrg] = useState([]);
  const [recPartnersArr, setRecPartnersArr] = useState([]);
  const customerTypes = ["Internal", "External"];
  const isActiveItems = ["True", "False"];

  const [atvBtn, setAtvBtn] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]

  const getData = async () => {
    setIsDataLoaded(false);
    let data = await getCustomerTypes();
    let allDataSet = data.data.data;

    for (let i = 0; i < allDataSet.length; i++) {
      let recOrgs = allDataSet[i].recruitmentpartnercustomers;
      let recOrgsName = recOrgs
        .map((item) => item.recruitmentpartner?.name)
        .join(", ");
      allDataSet[i].recOrgsNameStr = recOrgsName;

      let date = allDataSet[i]?.createdAt;
      let convertedDate = DateTime.fromISO(date)
        .toLocal()
        .startOf("day")
        .toJSDate();
      allDataSet[i].createdTime = convertedDate;
    }

    setAllData(allDataSet);

    // Recruitment Partner api call for getting all recruitment partner name
    let recOrgRes = await getAllRecruitmentPartnersAndClients();
    let recOrgData = recOrgRes.data.data;

    setRecruiterData(recOrgData.filter((item) => item.isActive === true));
    setIsDataLoaded(true);
  };

  const clearData = () => {
    setCustomerInfo({
      custName: "",
      status: "",
      custType: "",
      customerId: "",
    })
  };

  const closeButton = {
    position: "absolute",
    right: "7px",
    top: "12px",
    color: "grey",
  };


  const getUserID = localStorage.getItem("userID");

  const handleClosed = () => {
    setIsOpend((prev) => (prev = false));
  };

  // Handle Edit Action
  const handelEditClick = (e, value) => {
    setIsOpend(true);
    if (value.isActive === true) {
      setCustomerInfo({ ...customerInfo, status: "true", custName: value.name, custType: value.customerType, customerId: value.id })
    } else {
      setCustomerInfo({ ...customerInfo, status: "false", custName: value.name, custType: value.customerType, customerId: value.id })
    }
    const recruit = value?.recruitmentpartnercustomers;
    setRecruitOrg(recruit);

    const recruitArr = [];

    for (let i = 0; i < recruit.length; i++) {
      recruitArr.push(recruit[i]?.recruitmentpartner?.id);
    }

    hanRecruitmentOrgsName(recruitArr);
  };

  const handleisActive = (e, value) => {
    if (value === "True") {
      setCustomerInfo({ ...customerInfo, status: "true" })
    } else if (value === null) {
      setCustomerInfo({ ...customerInfo, status: "undefined" })
    } else {
      setCustomerInfo({ ...customerInfo, status: "false" })
    }
  };

  const handleName = (e) => {
    setCustomerInfo({ ...customerInfo, custName: e.target.value })
  };

  const handleCustomerType = (e, value) => {
    setCustomerInfo({ ...customerInfo, custType: value })
  };

  const handleRecruiterName = (e, value) => {
    let recruitmentPartnerId = value.map((item) => item.id);
    setRecruitmentPartnerArr(recruitmentPartnerId);
  };

  const getValue = (selected) => {
    const values = [];
    selected = selected.map((item, i) => item?.recruitmentpartner);
    for (let i = 0; i < recruiterData.length; i++) {
      for (let j = 0; j < selected.length; j++) {
        if (recruiterData[i].name === selected[j]?.name) {
          values.push(recruiterData[i]);
        }
      }
    }

    return values;
  };

  // This is for Edit Recruitment Organization
  const handleRecruitmentPartnersClick = (e, value) => {
    let cud = value.map((item) => item.id);
    setRecPartnersArr(cud);
  };

  // This is for Edit Recruitment Organization
  const hanRecruitmentOrgsName = (value) => {
    setRecPartnersArr(value);
  };

  useEffect(() => {
    getData();
  }, []);
  
  const editCustomer = async () => {
    setAtvBtn(true)
    var custData = {
      name: customerInfo.custName,
      code: customerInfo.custName,
      customerType: customerInfo.custType,
      recruitmentpartnerId: recPartnersArr,
      isActive: customerInfo.status,
      updatedBy: getUserID,
    };
    let Id = customerInfo.customerId;

    if (
      custData.name === undefined ||
      custData.name === "" ||
      custData.customerType === undefined ||
      custData.customerType === "" ||
      custData.isActive === undefined ||
      custData.recruitmentpartnerId.length < 1
    ) {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please fill all the mandatory fields.",
        "Error",
        10000
      );
    } else {
      try {
        const custResponse = await axios.put(
          jsonConfig.apiUrl + "customers/" + Id,
          custData,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        getData();


        if (
          custResponse.data.message ===
          "This Customer name already exists Please use a different Customer name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Customer name already exists. Please use a different Customer name.",
            "Error",
            10000
          );
        } else {
          NotificationManager.success(
            "Customer updated successfully.",
            "Success",
            10000
          );
          handleClosed();
          clearData();
          setAtvBtn(false)
        }
      } catch (error) {
        console.log(error);
        setAtvBtn(false)
      }
    }
  };

  const createCustomer = async () => {
    setAtvBtn(true)
    var custData = {
      name: customerInfo.custName,
      code: customerInfo.custName,
      recruitmentpartnerId: recruitmentPartnerArr,
      customerType: customerInfo.custType,
      isActive: customerInfo.status,
      createdBy: getUserID,
    };

    if (
      custData.name === undefined ||
      custData.name === "" ||
      custData.customerType === undefined ||
      custData.isActive === undefined
    ) {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please fill all the mandatory fields.",
        "Error",
        10000
      );
    } else {
      try {
        const custResponse = await axios.post(
          jsonConfig.apiUrl + "customers",
          custData,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        getData();
        if (
          custResponse.data.message ===
          "This Customer name already exists Please use a different Customer name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Customer name already exists. Please use a different Customer name.",
            "Error",
            10000
          );
        } else {

          NotificationManager.success(
            "Customer added successfully.",
            "Success",
            10000
          );
          setOpenModal(false);
          clearData();
          setAtvBtn(false)
        }
      } catch (error) {
        console.log(error);
        setAtvBtn(false)
      }
    }
  };

  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.createdAt;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    return filterValue ? new Date(filterValue) : null;
  }

  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  const columns = [
    {
      accessorKey: 'Action',
      header: 'Action',
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <Button
          onClick={(e) =>
            handelEditClick(row.original, row.original)
          }
          variant="contained"
          color="primary"
        >
          Edit
        </Button>
      ),
      size: 100,
    },
    {
      accessorKey: 'name',
      header: "Name",
      enableColumnFilter: true,
      enableSorting: true,
      size: 200,
    },
    {
      accessorKey: 'recOrgsNameStr',
      header: "Recruitment Organizations",
      enableColumnFilter: true,
      enableSorting: true,
      size: 230,
    },
    {
      accessorKey: 'customerType',
      header: "Customer Type",
      enableColumnFilter: true,
      enableSorting: true,
      size: 200,
    },
    {
      accessorKey: 'createdTime',
      header: 'Created At',
      size: 235,
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        <>
          {DateTime.fromISO(row.original.createdAt)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>
      )
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 80,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ]

  return (
    <>
      <div className="containerMain_recPartnersAndClients">
        <DataTable
          data={allData}
          columns={columns}
          isLoading={!isDataLoaded}
          className="table_recPartnersAndClients"
          initialColumnFilters={[
            {
              id: 'isActive',
              value: 'true'
            }
          ]}
        />
      </div>
      {/* ----------------- Add Cutomer -------------------- */}
      <Dialog
        onClose={() => setOpenModal(false)}
        aria-labelledby="customized-dialog-title"
        open={openModal}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="creatTest_title">
          <DialogTitle
            id="customized-dialog-title"
            className="admindailog_title_modal_recruitmentpartners"
            onClose={() => setOpenModal(false)}
          >
            Add Customer
            <IconButton
              aria-label="close"
              style={closeButton}
              onClick={() => setOpenModal(false)}
            >
              <Close />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <Typography gutterBottom>Recruitment Organizations*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              multiple
              options={recruiterData}
              getOptionLabel={(option) => option.name}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Recruitment Organizations"
                />
              )}
              onChange={handleRecruiterName}
            />
          </FormControl>
          &nbsp;
          <Typography>Customer Type*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={customerTypes}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Customer Type"
                />
              )}
              onChange={handleCustomerType}
            />
          </FormControl>
          &nbsp;
          <Typography gutterBottom>Customer Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              placeholder="Enter Customer Name"
              className="admin_textbox"
              onChange={handleName}
            />
          </FormControl>
          &nbsp;
          <Typography>Is Active*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={isActiveItems}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Status"
                />
              )}
              onChange={handleisActive}
            />
          </FormControl>
          &nbsp;
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>

            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={createCustomer}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
      </Dialog>

      {/* ----------------- Edit Cutomer -------------------- */}
      <Dialog
        onClose={handleClosed}
        aria-labelledby="customized-dialog-title"
        open={isOpend}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="creatTest_title">
          <DialogTitle
            id="customized-dialog-title"
            className="admindailog_title_modal_recruitmentpartners"
            onClose={handleClosed}
          >
            Edit Customer
            <IconButton
              aria-label="close"
              style={closeButton}
              onClick={handleClosed}
            >
              <Close />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <Typography gutterBottom>Recruitment Organizations*</Typography>
          {recruitOrg.length !== 0 ? (
            <>
              <FormControl fullWidth variant="outlined">
                <Autocomplete
                  multiple
                  options={recruiterData}
                  defaultValue={getValue(recruitOrg)}
                  getOptionLabel={(option) => option.name}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Recruitment Organizations"
                    />
                  )}
                  onChange={handleRecruitmentPartnersClick}
                />
              </FormControl>
            </>
          ) : (
            <>
              <FormControl fullWidth variant="outlined">
                <Autocomplete
                  multiple
                  options={recruiterData}
                  getOptionLabel={(option) => option.name || ""}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Recruitment Organizations"
                    />
                  )}
                  onChange={handleRecruitmentPartnersClick}
                />
              </FormControl>
            </>
          )}
          &nbsp;
          <Typography>Customer Type*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={customerTypes}
              value={customerInfo.custType || ""}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Customer Type"
                />
              )}
              onChange={handleCustomerType}
            />
          </FormControl>
          &nbsp;
          <Typography gutterBottom>Customer Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              placeholder="Enter Customer Name"
              className="admin_textbox"
              defaultValue={customerInfo.custName}
              onChange={handleName}
            />
          </FormControl>
          &nbsp;
          <Typography>Is Active*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={isActiveItems}
              // defaultValue={status === "true" ? "True" : "False"}
              value={customerInfo.status === null ? null : (customerInfo.status === "true" || customerInfo.status === true ? "True" : "False")}

              getOptionLabel={(option) => option || ""}
              getOptionSelected={(option, value) => option === (value === true ? "True" : "False")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Status"
                />
              )}
              onChange={handleisActive}
            />
          </FormControl>
          &nbsp;
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={handleClosed}>
              Cancel
            </Button>

            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={editCustomer}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
      </Dialog>
      <NotificationContainer />
    </>
  );
};

export default Customer;
